var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isBought)?_c('div',[_vm._v(" owned ")]):_vm._e(),(_vm.isUseless)?_c('div',[_vm._v("Doomed by Pelle")]):_vm._e(),(_vm.hasConnections)?_c('div',[_vm._v(" "+_vm._s(_vm.srConnections)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }